export default {
  // Hero section
  'hero.title': 'Alat Pemasa Dalam Talian Profesional',
  'hero.subtitle': 'Pilih alat masa yang sempurna untuk keperluan anda',

  // Tool cards
  'timer.title': 'Pemasa',
  'timer.description': 'Pemasa kira detik untuk kerja, belajar, dan kehidupan',
  'timer.longDescription': 'Pemasa kira detik untuk produktiviti, memasak, dan pengurusan masa',
  'timer.button': 'Mulakan Pemasa',

  'stopwatch.title': 'Jam Randik',
  'stopwatch.description': 'Alat masa ketepatan tinggi',
  'stopwatch.longDescription': 'Jam randik ketepatan tinggi untuk sukan, latihan, dan masa yang tepat',
  'stopwatch.button': 'Mulakan Jam Randik',

  'worldclock.title': 'Jam Dunia',
  'worldclock.description': 'Lihat zon waktu di seluruh dunia',
  'worldclock.longDescription': 'Paparan masa sebenar bandar-bandar utama global dengan pengiraan zon waktu pintar',
  'worldclock.button': 'Lihat Jam Dunia',

  // Features section
  'features.title': 'Mengapa Pilih timer.today?',
  'features.reliable.title': 'Boleh Dipercayai & Tepat',
  'features.reliable.desc': 'Masa ketepatan milisaat dengan kebolehpercayaan berasaskan pelayar',
  'features.crossPlatform.title': 'Merentas Platform',
  'features.crossPlatform.desc': 'Berfungsi dengan lancar pada desktop, tablet, dan peranti mudah alih',
  'features.smartNotifications.title': 'Pemberitahuan Pintar',
  'features.smartNotifications.desc': 'Amaran bunyi dan pemberitahuan desktop apabila masa tamat',
  'features.easyToUse.title': 'Mudah Digunakan',
  'features.easyToUse.desc': 'Antara muka bersih dengan kawalan intuitif untuk semua pengguna',

  // Keywords section
  'keywords.timer': 'pemasa kira detik pomodoro fokus kerja rehat',
  'keywords.chinese': '计时器 倒计时 番茄钟 专注 休息',
  'keywords.japanese': 'タイマー カウントダウン ポモドーロ 集中 休憩',
  'keywords.spanish': 'temporizador cuenta regresiva pomodoro concentración',
  'keywords.german': 'Timer Countdown Pomodoro Konzentration Pause',
  'keywords.french': 'minuteur compte à rebours pomodoro concentration',
  'keywords.russian': 'таймер обратный отсчет помодоро концентрация',
};
